import type { RoundingOccurrence } from '@pigello/pigello-matrix';
import { createDelegationOfferHandler } from './shared-delegation-offer-handler';

// Custom handler for Rounding Occurrence
export const handleCustomRoundingOccurrenceNestedCase =
  createDelegationOfferHandler<RoundingOccurrence>(
    'rounding_occurrence',
    (offer) => offer.roundingOccurrence?.id
  );
